
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { ComboBox } from 'office-ui-fabric-react/lib/ComboBox';
import { mergeStyleSets } from '@uifabric/merge-styles';

const classNames = mergeStyleSets({
    valSum: {
        width: '200px',
        display: 'flex',
        justifyContent: 'flex-end'
    },

    valQua: {
        width: '200px',
        display: 'flex',
        justifyContent: 'flex-end'
    },

    info: {
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-start'
    },

    combo: {
        width: '100%',
    }

})

const Operation = ({
    onOperationItemChange,
    operation,
    operationItems,
    calculationOperation,
    quantity
}) => {

    const handleOperationItemChange = (e, item) => {
        if (onOperationItemChange) {
            onOperationItemChange(item.operationItem);
        }
    }

    const getOptions = () => {
        return (operationItems.length > 0)
            ? operationItems.map(item => {
                return {
                    key: item.id,
                    text: item.title,
                    operationItem: item
                };
            })
            : [{key: '', text: '<<položka ceníku neexistuje>>'}];
    }

    const getSelectedCalculationOperation = () => {
        return (calculationOperation)
            ? calculationOperation.itemId
            : '';
    }

    const getPrice = () => {
        return (calculationOperation)
            ? new Intl.NumberFormat('cs-CZ', { style: 'currency', currency: 'CZK' }).format(calculationOperation.pricePerUnit * quantity)
            : `-`;
    }

    const getPricePerUnit = () => {
        return (calculationOperation)
            ? `${new Intl.NumberFormat('cs-CZ', { style: 'currency', currency: 'CZK' }).format(calculationOperation.pricePerUnit)}/${getUnit()}`
            : `-`;
    }

    const getUnit = () => {
        return (operation.mj === 'm2') ? 'm²' : 'm³';
    }

    return (
        <Stack horizontal tokens={{childrenGap: 5}}>
            <Stack.Item className={classNames.info}>{operation.title}</Stack.Item>
            <Stack.Item className={classNames.combo}>
                <ComboBox
                    selectedKey={getSelectedCalculationOperation()}
                    options={getOptions()}
                    onChange={handleOperationItemChange}
                />
            </Stack.Item>
            <>
                <Stack.Item className={classNames.valQua}>
                    {getPricePerUnit()}
                </Stack.Item>
                <Stack.Item className={classNames.valSum}>
                    {getPrice()}
                </Stack.Item>
            </>
        </Stack>
    );
}

//<Stack.Item grow>{quantity} {operation.mj}</Stack.Item>

export default Operation;
